import type { SceneRegistry } from "@/core/scene/types";

import { createMainScene } from "./MainScene";

/**
 * Registre des scènes du jeu.
 *
 * Typé `Record<SceneId, SceneFactory>` : ajouter un identifiant dans
 * `sceneId.ts` sans brancher sa fabrique ici casse la compilation.
 */
export const sceneRegistry: SceneRegistry = {
  main: createMainScene,
};

export type { SceneId } from "./sceneId";
